import { Outlet, RouteObject } from "react-router-dom";

import {
  // BUSHA_ASSETS_PAGE,
  BUSHA_ROOT,
  // BUSHA_TEST_ASSETS_PAGE,
  BUSHA_TRANSFER_CONFIRM_PAGE,
  TRANSFER_ROOT,
  // PAYMENT_METHOD_ROUTE,
  ASSETS_SELECTION_PAGE,
  PAYMENT_PAGE,
} from "app/constants/routes";

import Home from "app/views/PaymentMethod";
import BushaLogin from "app/views/Busha/Login";
// import BushaAssetsSelection from "app/views/Busha/AssetsSelection";
import BushaTransferConfirm from "app/views/Busha/TransferConfirm/index";
import AssetsSelection from "app/views/Transfer/AssetsSelection/index";
import Payment from "app/views/Transfer/Payment/index";
// import ProductPage from "app/views/ProductPage";
// import TestAssetsSelection from "app/views/Busha/TestAssetsSelection";

const routes: RouteObject[] = [
  // {
  //   path: HOME_ROUTE,
  //   element: <ProductPage />,
  // },

  {
    // path: PAYMENT_METHOD_ROUTE,
    index: true,
    element: <Home />,
  },

  {
    path: BUSHA_ROOT,
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <BushaLogin />,
      },

      // {
      //   path: BUSHA_ASSETS_PAGE,
      //   element: <BushaAssetsSelection />,
      // },

      {
        path: BUSHA_TRANSFER_CONFIRM_PAGE,
        element: <BushaTransferConfirm />,
      },
      // {
      //   path: BUSHA_TEST_ASSETS_PAGE,
      //   element: <TestAssetsSelection />,
      // },
    ],
  },

  {
    // index: true,
    path: TRANSFER_ROOT,
    element: <Outlet />,
    children: [
      {
        // index: true,
        path: ASSETS_SELECTION_PAGE,
        element: <AssetsSelection />,
      },

      {
        path: PAYMENT_PAGE,
        // index: true,
        element: <Payment />,
      },
    ],
  },
];

export default routes;
